import '@dafcoe/vue-notification/dist/vue-notification.css'

export default {
    name: 'Notification'
}